/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskProcessStatusType } from './ExecRiskProcessStatusType';
import {
    ExecRiskProcessStatusTypeFromJSON,
    ExecRiskProcessStatusTypeFromJSONTyped,
    ExecRiskProcessStatusTypeToJSON,
} from './ExecRiskProcessStatusType';

/**
 * 
 * @export
 * @interface ExecRiskApiAppCoreModelsTriggerStatus
 */
export interface ExecRiskApiAppCoreModelsTriggerStatus {
    /**
     * 
     * @type {ExecRiskProcessStatusType}
     * @memberof ExecRiskApiAppCoreModelsTriggerStatus
     */
    status: ExecRiskProcessStatusType;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsTriggerStatus
     */
    started: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsTriggerStatus
     */
    finished: string;
}

/**
 * Check if a given object implements the ExecRiskApiAppCoreModelsTriggerStatus interface.
 */
export function instanceOfExecRiskApiAppCoreModelsTriggerStatus(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "started" in value;
    isInstance = isInstance && "finished" in value;

    return isInstance;
}

export function ExecRiskApiAppCoreModelsTriggerStatusFromJSON(json: any): ExecRiskApiAppCoreModelsTriggerStatus {
    return ExecRiskApiAppCoreModelsTriggerStatusFromJSONTyped(json, false);
}

export function ExecRiskApiAppCoreModelsTriggerStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskApiAppCoreModelsTriggerStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': ExecRiskProcessStatusTypeFromJSON(json['status']),
        'started': json['started'],
        'finished': json['finished'],
    };
}

export function ExecRiskApiAppCoreModelsTriggerStatusToJSON(value?: ExecRiskApiAppCoreModelsTriggerStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': ExecRiskProcessStatusTypeToJSON(value.status),
        'started': value.started,
        'finished': value.finished,
    };
}

